module.exports = __webpack_public_path__ + "fonts/KaushanScript-Regular.ce2ee1ee.woff2";